export default class ConvertDataArray {
  static convert(data, configuration = "data") {
    let keys;

    switch (configuration) {
      case "data":
        keys = ["origsize", "size", "recency", "avg_silhouette"];
        break;
      case "filtdata" || "focusdata":
        keys = ["filtsize", "filtrecency", "linked", "relrecency", "relsize"];
        break;
    }

    let o = {};

    data.forEach((val, c) => {
      if (val === "inf") {
        val = 3;
      } else if (val === "-inf") {
        val = -3;
      }
      o[keys[c]] = val;
    });

    return o;
  }
}
